import { render, staticRenderFns } from "./listSetting.vue?vue&type=template&id=2849797a&scoped=true&"
import script from "./listSetting.vue?vue&type=script&lang=js&"
export * from "./listSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2849797a",
  null
  
)

export default component.exports